import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(() => ({
  container: {
    minHeight: 200,
  },
}));

export default useStyles;
